import React from 'react';
import PropTypes from 'prop-types';

class Thermometer extends React.Component {
  constructor(args) {
    super(args);

    this.validateProps();
  }

  render() {
    const rightWidth = (100 - this.props.upperBound);
    const leftWidth  = this.props.lowerBound;
    return (
      <div className="thermometer">
        <div className="thermometer__color-bar"/>
        <span className="thermometer__overlay-bar--left"
              style={{"width" : `${leftWidth}%`}}
              data-test-id="left-overlay-bar">
          <span className="thermometer__text-box--left ml-auto" data-test-id="left-text-box">
            {`${this.props.lowerBound}%`}
          </span>
        </span>
        <span className="thermometer__overlay-bar--right"
              style={{"width" : `${rightWidth}%`}}
              data-test-id="right-overlay-bar">
          <span className="thermometer__text-box--right mr-auto" data-test-id="right-text-box">
            {`${this.props.upperBound}%`}
          </span>
        </span>
      </div>
    );
  }

  validateProps() {
    if (this.props.lowerBound < 0 || this.props.upperBound > 100) {
      throw new Error("Invalid parameter! Ranges must be between 0 and 100 to render this component");
    }
    if (this.props.lowerBound > this.props.upperBound) {
      throw new Error("Invalid parameter! The lower bound must be less than or equal to the upper bound");
    }
  }
}

Thermometer.propTypes = {
  lowerBound: PropTypes.number.isRequired,
  upperBound: PropTypes.number.isRequired
};

export default Thermometer;
